import React from 'react';
import { ArrowRight, Cloud, Code, Zap } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 overflow-hidden pt-20 md:pt-0">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-20 h-20 bg-white rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-16 h-16 bg-white rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white rounded-full animate-pulse delay-500"></div>
        <div className="absolute bottom-40 right-10 w-12 h-12 bg-white rounded-full animate-pulse delay-700"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left animate-fade-in-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Scale Your Business with
              <span className="text-primary-200 block">
                Cloud Excellence
              </span>
            </h1>
            <p className="text-xl text-primary-100 mb-8 leading-relaxed">
              Cutting-edge software development, DevOps, and cloud operations enterprise 
              based in the UK. We empower businesses by scaling their digital infrastructure 
              efficiently and securely.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button 
                onClick={() => scrollToSection('#services')}
                className="btn-primary flex items-center justify-center space-x-2 bg-white text-primary-700 hover:bg-primary-50"
              >
                <span>Our Services</span>
                <ArrowRight size={20} />
              </button>
              <button 
                onClick={() => scrollToSection('#contact')}
                className="btn-secondary border-white text-white hover:bg-white hover:text-primary-700"
              >
                Get In Touch
              </button>
            </div>
          </div>

          {/* Visual Elements */}
          <div className="relative animate-slide-in-right">
            <div className="relative z-10">
              {/* Main Cloud Icon */}
              <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-3xl p-8 mb-6">
                <Cloud size={120} className="text-white mx-auto" />
              </div>
              
              {/* Floating Icons */}
              <div className="absolute -top-4 -right-4 bg-primary-400 rounded-full p-4 animate-bounce">
                <Code size={24} className="text-white" />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-primary-300 rounded-full p-4 animate-bounce delay-500">
                <Zap size={24} className="text-white" />
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="animate-fade-in-up delay-300">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">100+</div>
            <div className="text-primary-200">Projects Delivered</div>
          </div>
          <div className="animate-fade-in-up delay-500">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">24/7</div>
            <div className="text-primary-200">Cloud Support</div>
          </div>
          <div className="animate-fade-in-up delay-700">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">99.9%</div>
            <div className="text-primary-200">Uptime Guarantee</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full opacity-75">
          <div className="w-1 h-3 bg-white rounded-full mx-auto mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
